import { Column, Entity, OneToMany, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IRefRankingEstablishment } from './interface/IRefRankingEstablishment';
import { IRanking } from './interface/IRanking';

@Entity('ref_ranking_establishment')
export class RefRankingEstablishment extends BaseEntity implements IRefRankingEstablishment{
  apiMapping = {
      id: 'id',
      name: 'name',
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column()
  name: string;

  @Column({ nullable: true })
  isDeleted: boolean;

  @OneToMany('Ranking', 'refRankingEstablishment')
  verificationRanking: IRanking[];
}
